import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {RELATES_TO_SEARCH_FEATURE_FLAG} from '@github-ui/shared-filter-providers/constants'
import {useFilterProviders} from '@github-ui/shared-filter-providers/providers/use-filter-providers'

interface UseSavedViewFilterProvidersOptions {
  owner: string
  repo: string
}

export function useSavedViewFilterProviders({owner, repo}: UseSavedViewFilterProvidersOptions) {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     The monolith publishes this flag to the issues-react app payload via `add_client_feature_flag`
     (repo/org/user gated), so it must be read with `useFeatureFlag`, not `isFeatureEnabled`. */
  const relatesToEnabled = useFeatureFlag(RELATES_TO_SEARCH_FEATURE_FLAG)

  return useFilterProviders({
    repositoryScope: owner && repo ? `${owner}/${repo}` : undefined,
    isOrgScope: true,
    isIssueFieldsEnabled: true,
    isIssueSearchScope: true,
    relatesToEnabled,
  })
}
